module.exports = __webpack_public_path__ + "static/lageplan_wanderfahrradwege-9e63f4eeec4164a6358821e7e68cfc40.png";